const p = (c, o = "-") => c == null ? void 0 : c.replace(/\s/g, o);
export {
  p as removeSpaces
};
//# sourceMappingURL=index.es666.js.map
